import React, { useState } from "react";

export const inviteUrl = (origin = window.location.origin) => `${origin}/auth`;

export const INVITE_TEXT = (origin = window.location.origin) =>
  `I'm on Predict90. Pick football scores before lock — 5 points for exact.\n${inviteUrl(origin)}`;

async function copyText(text) {
  try {
    if (navigator.clipboard?.writeText) {
      await Promise.race([
        navigator.clipboard.writeText(text),
        new Promise((_, reject) => window.setTimeout(() => reject(new Error("timeout")), 800)),
      ]);
      return true;
    }
  } catch {
    /* fall through */
  }
  try {
    const el = document.createElement("textarea");
    el.value = text;
    el.setAttribute("readonly", "");
    el.style.position = "fixed";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    el.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(el);
    return ok;
  } catch {
    return false;
  }
}

export default function InviteFriendButton({ className = "", label = "Invite a friend" }) {
  const [copied, setCopied] = useState(false);

  const share = async () => {
    const ok = await copyText(INVITE_TEXT());
    if (ok) {
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <button type="button" onClick={share} className={className}>
      {copied ? "Invite copied" : label}
    </button>
  );
}
